import {TRANSITION_ENDED} from '../constants/animations';

export const transitionEnd = () => {
	return {
		type: TRANSITION_ENDED,
		payload: {}
	};
};